import api from './api';

export const raiseDispute = async (disputeData) => {
  const response = await api.post('/disputes/', disputeData);
  return response.data;
};

export const getMyDisputes = async () => {
  const response = await api.get('/disputes/my');
  return response.data;
};

export const getAllDisputes = async () => {
  const response = await api.get('/disputes/all');
  return response.data;
};

export const addressDispute = async (disputeId) => {
  const response = await api.patch(`/disputes/${disputeId}/address`);
  return response.data;
};
